import {PhoneGateway} from '../../gateways/phone.gateway';
import {QuoteWizardStateService} from '../../../quoteWizardState.service';
import {QuoteWizardNavigationService} from '../../../quoteWizardNavigation.service';
import {QuoteWizardDefaultViewController} from '../../../quoteWizardDefaultView.controller';
import {IPhone} from '../../../../models/phone.model';
import {ScreenLockService} from '../../../../core/services/screenLockService/screenLock.service';

export class PhoneController extends QuoteWizardDefaultViewController {
    public static $inject = ['$stateParams', 'quoteWizardStateService', 'quoteWizardNavigationService', 'phone.gateway', 'screenLockService'];

    constructor(public parameters: any,
                public stateService: QuoteWizardStateService,
                protected navigationService: QuoteWizardNavigationService,
                private phoneGateway: PhoneGateway,
                private screenLockService: ScreenLockService) {
        super(parameters, stateService, navigationService);
    }

    protected activate(): void {
        this.stateService.showViewLockIfStillWaitingOnPromise(this.stateService.viewModel.phonePromise);
        this.stateService.viewModel.phonePromise.then(() => {
            this.screenLockService.broadcast(0);
            super.activate();
        });
    }

    public goNext() {
        this.phoneGateway.savePhone(this.stateService.viewModel.phone)
        .then((phone: IPhone) => {
            this.stateService.viewModel.phone = phone;
        });
        super.goNext();
    }
}